module.exports = __webpack_public_path__ + "static/img/메달-역사.d9046a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/메달-역사.png
// module id = j/a1
// module chunks = 0